export default __webpack_public_path__ + "static/media/4.e9a0c4b2.jpg";